export class LoginByTokenModel {
	public accessToken: string;
	public refreshToken: string;
	public userType: string;
	public name: string;
	public email: string;
	public id: string;
	public lang: string;
	public roles: string[];
	public isSupervisor: boolean;

	public convert(dto: any): LoginByTokenModel {
		if (dto.accessToken) {
			this.accessToken = dto.accessToken;
		}
		if (dto.refreshToken) {
			this.refreshToken = dto.refreshToken;
		}
		if (dto.userType) {
			this.userType = dto.userType;
		}
		if (dto.name) {
			this.name = dto.name;
		}
		if (dto.id) {
			this.id = dto.id;
		}
		if (dto.lang) {
			this.lang = dto.lang;
		}
		if (dto.roles) {
			this.roles = dto.roles;
		}
		if (dto.isSupervisor !== undefined && dto.isSupervisor !== null) {
			this.isSupervisor = dto.isSupervisor;
		}

		return this;
	}

	public storeAuthToLocalStorage(data: LoginByTokenModel) {
		localStorage.setItem('superAppsBack.accessToken', data.accessToken);
		localStorage.setItem('superAppsBack.refreshToken', data.refreshToken);
		localStorage.setItem('superAppsBack.userType', data.userType);
		localStorage.setItem('superAppsBack.name', data.name);
		localStorage.setItem('superAppsBack.id', data.id);
		localStorage.setItem('superAppsBack.lang', data.lang);
		localStorage.setItem('superAppsBack.roles', JSON.stringify(data.roles));
		localStorage.setItem(
			'superAppsBack.isSupervisor',
			JSON.stringify(!!data.isSupervisor)
		);
	}
}
